import { render, staticRenderFns } from "./scene-skill.vue?vue&type=template&id=71db7bf0&scoped=true&"
import script from "./scene-skill.vue?vue&type=script&lang=js&"
export * from "./scene-skill.vue?vue&type=script&lang=js&"
import style0 from "./scene-skill.vue?vue&type=style&index=0&id=71db7bf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71db7bf0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/fcs/fcs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71db7bf0')) {
      api.createRecord('71db7bf0', component.options)
    } else {
      api.reload('71db7bf0', component.options)
    }
    module.hot.accept("./scene-skill.vue?vue&type=template&id=71db7bf0&scoped=true&", function () {
      api.rerender('71db7bf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/scene-skill.vue"
export default component.exports